<template>
    <div>
        <div v-if="null != list && list.length > 0">
            <CompanyAuthRecord
                v-for="v in list"
                :obj="v"
                :key="v.id"
                @clickSave="clickSaveCallback"
                @clickInsert="clickInsertCallback"
            />
        </div>

        <div v-if="null == list || list.length === 0">
            <CompanyAuthRecord
                :obj="null"
                tag="empty"
                @clickSave="clickSaveCallback"
                @clickInsert="clickInsertCallback"
            />
        </div>
    </div>
</template>

<script setup>

import CompanyAuthRecord from "@/components/shopopee/company/auth/companyAuthRecord.vue";

const props = defineProps(["list"])
const emits = defineEmits(["clickSave", "clickInsert"])

function clickSaveCallback(obj){
    emits("clickSave", obj)
}

function clickInsertCallback(obj){
    emits("clickInsert", obj)
}

</script>

<style scoped>


</style>